import request from '@/utils/request'
import { fileService } from "@/api/common/file-utils";
export default {
    getList: (data) => {
        return request({
            url: 'five-bit-code/findListPage',
            method: 'post',
            data: data
        })
    },
    deleteBatch: (data) => {
        return request({
            url: 'five-bit-code/deleteFiveBitCode?tmFiveBitCodeIds=' + data,
            method: 'post',
            data: data
        })
    },
    getfiveBitCodeDetail: (id) => {
        return request({
            url: `/five-bit-code/${id}`,
            method: 'GET',
        })
    },
    findOneByCode: (id) => {
        return request({
            url: `/five-bit-code/findOneByCode?fiveBitCode=${id}`,
            method: 'post',
        })
    },
    //物料主数据GRI详情(通过id)
    findOneDetail: (id) => {
        return request({
            url: '/five-bit-code/findOne?id=' + id,
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            }
        })
    },
    saveGRI: (data) => request({
        url: `five-bit-code/saveFiveBitCode`,
        method: 'post',
        data: data
    }),
    disableCategory: (data) => request({
        url: `category/disable`,
        method: 'post',
        params: data
    }),
    addCategory: (data) => request({
        url: `category/saveCategory`,
        method: 'post',
        data: data
    }),
    saveCategory: (data) => request({
        url: `/category/saveCategory`,
        method: 'post',
        data: data
    }),
    //启用禁用
    disable: (data) => request({
        url: `/category/disable`,
        method: 'post',
        params: data
    }),
    //批量删除
    deleteBatchIds: (data) => request({
        url: `/category/deleteBatchIds?idList=${data}`,
        method: 'post'
    }),
    exportList: (param) => request({
        url: 'five-bit-code/download',
        method: 'post',
        fullResponse: true,
        responseType: 'blob',
        data: param
    }).then(resp => {
        fileService.respToFile(resp, 'GRI.xlsx');
    }),
}